import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { SERVICES } from "../config/content";
import { BUSINESS } from "../config/business";
import SEO from "../components/SEO";
import { FadeUp, MaskedLine } from "../components/anim";

export default function ServicesHub() {
  return (
    <div data-testid="services-hub">
      <SEO
        title={`Smog Check Services in Modesto, CA | ${BUSINESS.name}`}
        description="STAR smog checks, diesel smog, smog repairs, DMV registration renewal and title transfers in Modesto, CA. Walk-ins welcome."
        keywords="smog check services Modesto, STAR smog, diesel smog, DMV registration Modesto"
        path="/services"
      />
      <section className="bg-white aurora relative overflow-hidden">
        <div className="section relative z-10 py-14">
          <p className="kicker">Our Services</p>
          <h1 className="mt-2 font-head font-extrabold text-4xl sm:text-5xl text-ink max-w-3xl">
            <MaskedLine lines={[{ text: "Complete Smog & Registration Services" }]} />
          </h1>
          <p className="mt-4 text-ink/70 font-body max-w-2xl">Everything your vehicle needs to stay California-compliant — handled fast in one visit in Modesto.</p>
        </div>
      </section>

      <section className="section py-14 space-y-4">
        {SERVICES.map((s, i) => (
          <FadeUp key={s.slug} delay={i * 0.04}>
            <Link to={`/services/${s.slug}`} data-testid={`services-row-${s.slug}`} className="group flex items-center gap-5 card-soft p-6 hover:shadow-volt transition-shadow">
              <span className="font-head font-extrabold text-2xl text-volt/40 w-10">{String(i + 1).padStart(2, "0")}</span>
              <div className="flex-1">
                <h2 className="font-head font-bold text-lg text-ink">{s.title}</h2>
                <p className="mt-1 text-sm text-ink/70 font-body">{s.short}</p>
              </div>
              <ArrowRight className="h-5 w-5 text-volt group-hover:translate-x-1 transition-transform" />
            </Link>
          </FadeUp>
        ))}
      </section>

      <section className="bg-volt">
        <div className="section py-12 text-center">
          <h2 className="font-head font-extrabold text-3xl text-white">Not sure what you need?</h2>
          <a href={`tel:${BUSINESS.phoneTel}`} className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 font-head font-bold text-volt"><Phone className="h-4 w-4" /> {BUSINESS.phoneDisplay}</a>
        </div>
      </section>
    </div>
  );
}
